/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Psm_SparseInputs */



/**
* | output |
* | --- |
* | "Sparse Text (Scattered)" |
*
* @param {Ocr_Psm_SparseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_psm_sparse = /** @type {((inputs?: Ocr_Psm_SparseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Psm_SparseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Texte épars (dispersé)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wenig Text (verstreut)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Testo sparso (disseminato)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Разрозненный текст (рассеянный)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Texto disperso (disperso)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("稀疏文本（散乱）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("疎なテキスト（散在）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बिखरा हुआ पाठ (अस्त-व्यस्त)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Texto esparso (disperso)")
	return /** @type {LocalizedString} */ ("Sparse Text (Scattered)")
});